import { FC, useCallback } from 'react';
import { Checkbox } from 'dibs-elements/exports/Checkbox';
import { useFragment, graphql } from 'react-relay';
import { trackFormInteraction } from '../../helpers/checkoutTracking';
import { toggleMarketingOptInAction } from '../../actions/checkoutUIActions';
import { CheckoutRegistrationMarketingOptIn_viewer$key } from './__generated__/CheckoutRegistrationMarketingOptIn_viewer.graphql';
import { useAppDispatch, useCheckoutSelector } from '../../reducers/root';
import dibsCss from 'dibs-css';
import styles from './styles/CheckoutRegistrationMarketingOptIn.scss';

type Props = {
    viewer: CheckoutRegistrationMarketingOptIn_viewer$key | null;
};

export const CheckoutRegistrationMarketingOptIn: FC<Props> = ({ viewer: viewerRef }) => {
    const viewer = useFragment(
        graphql`
            fragment CheckoutRegistrationMarketingOptIn_viewer on Viewer {
                gdprDisplayInfo {
                    isGdprApplicable(countryCode: $userCountryCode)
                    marketingOptInMessage
                }
            }
        `,
        viewerRef
    );
    const dispatch = useAppDispatch();
    const isMarketingOptIn = useCheckoutSelector(state => state?.ui?.isMarketingOptIn);
    const onToggle = useCallback((): void => {
        trackFormInteraction();
        dispatch(toggleMarketingOptInAction());
    }, [dispatch]);

    const { isGdprApplicable, marketingOptInMessage } = viewer?.gdprDisplayInfo || {};

    if (!isGdprApplicable) {
        return null;
    }
    return (
        <Checkbox
            dataTn="register-gdpr-checkbox"
            name="registrationGdprCheckbox"
            label={marketingOptInMessage}
            checked={isMarketingOptIn}
            wrapperClass={`${dibsCss.mySmall} ${dibsCss.mx0}`}
            labelClass={`${dibsCss.sassyFontBodyMedium} ${styles.label} ${dibsCss.flex} ${dibsCss.itemsCenter}`}
            onChange={onToggle}
        />
    );
};
